import { render, staticRenderFns } from "./BonusRequest.vue?vue&type=template&id=d965de4a"
import script from "./BonusRequest.vue?vue&type=script&lang=js"
export * from "./BonusRequest.vue?vue&type=script&lang=js"
import style0 from "./BonusRequest.vue?vue&type=style&index=0&id=d965de4a&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports